import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import classNames from 'classnames';
import { Input } from '../Input/Input.es.js';
import { TextareaInner } from './Textarea.Inner.es.js';

const Textarea = /*#__PURE__*/ forwardRef(({ className, disabled, error, display, label, labelSuffix, loading, message, readOnly, value, warning, ...rest }, ref)=>{
    const fieldMultilineCss = classNames('cb-textarea', {
        'has-value': Boolean(value)
    }, className);
    return jsx(Input, {
        className: fieldMultilineCss,
        "data-testid": "textarea-container",
        disabled: disabled,
        display: display,
        error: error,
        label: label,
        labelSuffix: labelSuffix,
        loading: loading,
        message: message,
        readOnly: readOnly,
        value: value,
        warning: warning,
        children: jsx(Input.Field.Custom, {
            children: jsx(TextareaInner, {
                ref: ref,
                value: value,
                ...rest
            })
        })
    });
});
Textarea.displayName = 'Textarea';

export { Textarea, Textarea as default };
//# sourceMappingURL=Textarea.es.js.map
